import { debounce } from 'debounce';
import React, { useCallback } from 'react';

export default function DebounceButton({
  onClick, children, className, disabled = false,
}) {
  const debounceClick = debounce(() => onClick(), 300, true);
  const handleClick = useCallback(() => {
    debounceClick();
  }, []);
  return (
    <button className={className} disabled={disabled} type="button" onClick={handleClick}>{children}</button>
  );
}
